import { render, staticRenderFns } from "./StudioSettingsStudents.vue?vue&type=template&id=5e4dc332&scoped=true"
import script from "./StudioSettingsStudents.vue?vue&type=script&lang=ts&setup=true"
export * from "./StudioSettingsStudents.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./StudioSettingsStudents.vue?vue&type=style&index=0&id=5e4dc332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4dc332",
  null
  
)

export default component.exports